// extracted by mini-css-extract-plugin
export default {"container":"Header_container__vI36D","down":"Header_down__mFBbc","up":"Header_up__eB67-","extraPadding":"Header_extraPadding__OKoTG"};